module.exports = __webpack_public_path__ + "img/68400.8b55f53d.jpg";